module.exports = __webpack_public_path__ + "static/media/icon.f4e674b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/rlboe/icon.jpg
// module id = 1659
// module chunks = 0